import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as apiKeysApi from "@/lib/api/api-keys";

export function useApiKeys() {
  const { data, error, isLoading } = useQuery({
    queryKey: ["apiKeys"],
    queryFn: apiKeysApi.getApiKeys,
  });
  return { apiKeys: data ?? [], error, isLoading };
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiKeysApi.createApiKey,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["apiKeys"] }),
  });
}

export function useToggleApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiKeysApi.toggleApiKey,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["apiKeys"] }),
  });
}

export function useDeleteApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiKeysApi.deleteApiKey,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["apiKeys"] }),
  });
}
